import { toast } from "react-toastify";

export function useToast() {
  const showResponseMessages = async (
    status: number | string | undefined,
    message?: string,
    errors?: string[]
  ) => {
    if (status === 200) {
      message && toast["success"](message);
    } else {
      if (status === 400) {
        if (Array.isArray(errors) && errors.length > 0) {
          errors?.map((error: string) => {
            toast["error"](error);
          });
        } else {
          message && toast["error"](message);
        }
      } else {
        message && toast["error"](message);
      }
    }
  };

  return {
    showResponseMessages,
  };
}
